import { Textarea } from "@arcadeai/design-system/components/ui/atoms/textarea";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { Control } from "react-hook-form";
import type { McpServerCreateRequest } from "../../types";

type DescriptionFormFieldProps = {
  control: Control<McpServerCreateRequest>;
};

export function DescriptionFormField({ control }: DescriptionFormFieldProps) {
  return (
    <FormField
      control={control}
      name="description"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Description (optional)</FormLabel>
          <FormControl>
            <Textarea
              {...field}
              placeholder="e.g. Email and calendar tools for the support team's assistant."
              value={field.value ?? ""}
            />
          </FormControl>
          <FormDescription>
            A description of this gateway, for humans.
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
